export default __webpack_public_path__ + "static/media/image.b09ff9fa.png";